import { Mapper } from "../../../../../lib/utils/mapper";
import { Product } from "../../../../pages/ProductsListPage/entities/product/product.entity";
import type { IProduct } from "../../../../pages/ProductsListPage/entities/product/product.entity.interface";
import { SearchHistoryCachedDatasource } from "../../datasources/search-history/cached/search-history-cached.datasource";
import type { ISearchHistoryCachedDatasource } from "../../datasources/search-history/cached/search-history-cached.datasource.interface";
import { SearchHistoryRemoteDatasource } from "../../datasources/search-history/remote/search-history-remote.datasource";
import type { ISearchHistoryRemoteDatasource } from "../../datasources/search-history/remote/search-history-remote.datasource.interface";
import type { ISearchHistoryEntity } from "../../entities/search-history.entity";
import { SearchHistoryEntity } from "../../entities/search-history.entity";
import type { ISearchHistoryRepository } from "./search-history.repository.interface";

export class SearchHistoryRepository implements ISearchHistoryRepository {
  constructor(
    private readonly _searchHistoryDatasource: ISearchHistoryRemoteDatasource = new SearchHistoryRemoteDatasource(),
    private readonly _searchHistoryCachedDatasource: ISearchHistoryCachedDatasource = new SearchHistoryCachedDatasource()
  ) {}

  public async getProductsFromHistory(limit: number): Promise<IProduct[]> {
    const productsFromHistory = await this._searchHistoryDatasource.getProductHistory(limit);
    const productEntities = Mapper.mapArrayData(Product, productsFromHistory);
    return productEntities;
  }

  public async getSearchHistory(limit: number, forceFetch: boolean = false): Promise<ISearchHistoryEntity> {
    const cachedSearchHistory = this._searchHistoryCachedDatasource.getSearchHistory();
    if (cachedSearchHistory && !forceFetch) {
      return Mapper.mapData(SearchHistoryEntity, cachedSearchHistory);
    }

    try {
      const result = await this._searchHistoryDatasource.getSearchHistory(limit);
      const mappedResult = Mapper.mapData(SearchHistoryEntity, result);
      this._searchHistoryCachedDatasource.setSearchHistory(result);
      return mappedResult;
    } catch (error) {
      const emptySearchHistory = new SearchHistoryEntity([]);
      return emptySearchHistory;
    }
  }
}
